import { useQuery } from "@tanstack/react-query";
import { getDocuments } from "../../services/status_manager";

const useGetDocuments = (applicantId: number) => {
    return useQuery({
        queryFn: () => getDocuments(applicantId),
        queryKey: ["documents", applicantId],
        retry: 0,
        refetchOnWindowFocus: false,
    });
};
export default useGetDocuments;